// The 2x2 product block on Home keeps its fourth place for "Show all products" or "New product".
export const HOME_PRODUCT_CARD_COUNT = 3;
